import Model from 'lib/Model';
import config from 'config/index.js';

export default Model.extend({
	file: config.file.settings,

	defaults: {
		type: 'plan',
		zoom: 17,

		// Centré sur le siège de la FNE-AURA
		lat: 45.7458162,
		lng: 4.8342825,

		// Date de la dernière mise à jour !
		time: null,

		// Liste des dates de mises à jour pour chaque url
		modified: {},

		token: null,
	},

	setToken: function( token )
	{
		this.set( 'token', token || null );
	},

	clearToken: function()
	{
		this.unset( 'token' );
	},

	hasToken: function()
	{
		return !!this.get('token');
	},

	isAuthenticated: function()
	{
		return this.hasToken();
	},

	getLatLng: function()
	{
		return { lat: this.get('lat') || this.defaults.lat, lng: this.get('lng')  || this.defaults.lng };
	},


	getObjectUrl: function( obj )
	{
		try
		{
			return _.result( obj, 'url' );
		}
		catch( e )
		{
			return;
		}
	},

	isCollection: function( obj )
	{
		return !!( obj && obj.model && obj.models );
	},

	// Horodatage de référence après sync collection (max des objets synchronisés)
	getCollectionSyncTimestamp: function( collection )
	{
		var dates = collection.filter( function( m )
		{
			return !m.isNew() && !m.has('todo') && m.has('updated_at');
		}).map( function( m )
		{
			return m.get('updated_at');
		});

		return dates.length ? _.max( dates ) : null;
	},

	setModifiedSince: function( obj ) {
		if( !this.isCollection( obj ) ) {
			return;
		}

		var url = this.getObjectUrl( obj );
		if( !url ) {
			return;
		}

		var modified = this.get('modified');

		if( obj.isEmpty() )
		{
			if( modified[url] )
			{
				delete modified[url];
				this.set( 'modified', modified );
			}
			return;
		}

		var last = this.getCollectionSyncTimestamp( obj );

		if( !last ) {
			return;
		}

		// Vérifier que last est une date valide
		var date = this.parseModifiedDate( last );
		if( !date ) {
			console.warn('Invalid date for modified since:', last, 'for URL:', url);
			return;
		}

		modified[url] = last;
		this.set( 'modified', modified );
		console.log( 'SET MODIFIED SINCE', url, modified[url] );

		return last;
	},

	getModifiedSince: function( obj ) {
		var url = this.getObjectUrl( obj );
		if( !url ) {
			return;
		}

		var modified = this.get('modified');

		console.log( 'GET MODIFIED SINCE', url, modified[url] );
		return modified[url];
	},

	addIfModifiedSinceHeader( obj, options ) {
		options = options || {};

		if( options.force )
		{
			if( options.headers )
			{
				delete options.headers['If-Modified-Since'];
			}
			return options;
		}

		if( this.isCollection( obj ) && obj.isEmpty() )
		{
			return options;
		}

		var modified = this.isCollection( obj )
			? this.getModifiedSince( obj )
			: ( _.isFunction( obj.getIfModifiedSince ) ? obj.getIfModifiedSince() : null );

		return this._applyConditionalHeader( 'If-Modified-Since', modified, options );
	},

	addIfUnmodifiedSinceHeader: function( obj, options ) {
		if( !obj || obj.isNew() || !obj.has('updated_at') )
		{
			return options || {};
		}

		return this._applyConditionalHeader( 'If-Unmodified-Since', obj.get('updated_at'), options );
	},

	_applyConditionalHeader: function( name, modified, options ) {
		if( modified ) {
			var date = this.parseModifiedDate( modified );
			if( !date ) {
				console.warn('Invalid date for '+name+' header:', modified);
				return options;
			}

			options = options || {};
			options.headers = options.headers || {};
			options.headers[name] = date.toUTCString();
			console.log( 'ADD '+name+' HEADER', options.headers[name] );
		}

		return options;
	},

	parseModifiedDate: function( modified )
	{
		var date = new Date( modified );
		return isNaN( date.getTime() ) ? null : date;
	},
});
